import React, { useEffect, useRef } from "react";
import "../Css/heroSlider.css";
import NurtureCareGroup from "../Img/Nurture-Care-Group-img.jpg";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { Carousel } from "bootstrap";
import gsap from "gsap";

function Slider() {
  const carouselRef = useRef(null);
  const heroRef = useRef(null);

  // Bootstrap Carousel Auto Slider
  useEffect(() => {
    if (carouselRef.current) {
      const carousel = new Carousel(carouselRef.current, {
        interval: 3500,
        ride: "carousel",
        pause: false,
        touch: true,
        wrap: true,
      });

      return () => carousel.dispose();
    }
  }, []);

  useEffect(() => {
    if (!heroRef.current) return;

    const hero = heroRef.current;

    const handleMove = (e) => {
      const rect = hero.getBoundingClientRect();

      const x = (e.clientX - rect.left) / rect.width - 0.5;
      const y = (e.clientY - rect.top) / rect.height - 0.5;

      // ✅ Only active slide image (important)
      const activeImg = hero.querySelector(".carousel-item.active .hero-img");

      // background elements
      const moveSmall = hero.querySelectorAll(".move-sm");
      const moveMedium = hero.querySelectorAll(".move-md");
      const moveLarge = hero.querySelectorAll(".move-lg");

      // ✅ Move background layers
      gsap.to(moveSmall, {
        x: x * 15,
        y: y * 15,
        duration: 0.5,
        ease: "power3.out",
      });
      gsap.to(moveMedium, {
        x: x * 30,
        y: y * 30,
        duration: 0.6,
        ease: "power3.out",
      });
      gsap.to(moveLarge, {
        x: x * 45,
        y: y * 45,
        duration: 0.8,
        ease: "power3.out",
      });

      // ✅ Move only current hero image
      if (activeImg) {
        gsap.to(activeImg, {
          x: x * 50,
          y: y * 50,
          duration: 0.6,
          ease: "power3.out",
        });
      }
    };

    const handleLeave = () => {
      gsap.to(".move-sm, .move-md, .move-lg, .carousel-item.active .hero-img", {
        x: 0,
        y: 0,
        duration: 0.6,
        ease: "power3.out",
      });
    };

    hero.addEventListener("mousemove", handleMove);
    hero.addEventListener("mouseleave", handleLeave);

    return () => {
      hero.removeEventListener("mousemove", handleMove);
      hero.removeEventListener("mouseleave", handleLeave);
    };
  }, []);

  return (
    <>
      <section className="hero-slider" ref={heroRef}>
        {/* Background Elements */}
        <div className="hero-bg-elements">
          <div className="sun move-md" />
          <div className="cloud cloud-1 move-sm" />
          <div className="cloud cloud-2 move-md" />
          <div className="cloud cloud-3 move-lg" />
          <div className="wave move-sm" />
          <div className="wave wave-2 move-md" />
        </div>

        {/* Bootstrap Carousel */}
        <div
          ref={carouselRef}
          id="heroCarousel"
          className="carousel slide carousel-fade hero-carousel"
        >
          <div className="carousel-inner hero-content">
            {/* Slide 1 */}
            <div className="carousel-item active">
              <div className="container h-100">
                <div className="row align-items-center h-100 g-4">
                  <div className="col-12 col-md-6 text-center text-md-start">
                    <h1 className="hero-title animate-left">
                      Multifunctional <br /> Website
                    </h1>
                    <p className="hero-subtitle animate-up">
                      Optimized for work with touchscreen
                    </p>
                    <button className="hero-btn animate-up">BUY NOW</button>
                  </div>

                  <div className="col-12 col-md-6 text-center">
                    <img
                      className="hero-img animate-right move-lg"
                      style={{ position: "relative", zIndex: 5 }}
                      src="https://tse2.mm.bing.net/th/id/OIP.BfGl2Ni_U4_zOyWp-5KNYgHaFI?rs=1&pid=ImgDetMain&o=7&rm=3"
                      alt="Slide Image 1"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Slide 2 */}
            <div className="carousel-item">
              <div className="container h-100">
                <div className="row align-items-center h-100 g-4">
                  <div className="col-12 col-md-6 text-center text-md-start">
                    <h1 className="hero-title animate-left">
                      Creative <br /> Landing Page
                    </h1>
                    <p className="hero-subtitle animate-up">
                      Fast, clean and modern UI design
                    </p>
                    <button className="hero-btn animate-up">EXPLORE</button>
                  </div>

                  <div className="col-12 col-md-6 text-center">
                    <img
                      className="hero-img animate-right move-lg"
                      style={{ position: "relative", zIndex: 5 }}
                      src="https://tse1.mm.bing.net/th/id/OIP._QGlE8rKPNnsUvdXJA8W2gAAAA?w=370&h=370&rs=1&pid=ImgDetMain&o=7&rm=3"
                      alt="Slide Image 2"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Slide 3 */}
            <div className="carousel-item">
              <div className="container h-100">
                <div className="row align-items-center h-100 g-4">
                  <div className="col-12 col-md-6 text-center text-md-start">
                    <h1 className="hero-title animate-left">
                      Business <br /> Website
                    </h1>
                    <p className="hero-subtitle animate-up">
                      Perfect for startup &amp; corporate
                    </p>
                    <button className="hero-btn animate-up">GET STARTED</button>
                  </div>

                  <div className="col-12 col-md-6 text-center">
                    <img
                      className="hero-img animate-right move-lg"
                      style={{ position: "relative", zIndex: 5 }}
                      src="https://www.prattvilleymca.org/clientuploads/DG6A4253RGB.jpg"
                      alt="Slide Image 3"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Custom Controls */}
          <button
            className="carousel-control-prev custom-carousel-btn"
            type="button"
            data-bs-target="#heroCarousel"
            data-bs-slide="prev"
          >
            <span className="custom-icon">
              <FaChevronLeft />
            </span>
          </button>

          <button
            className="carousel-control-next custom-carousel-btn"
            type="button"
            data-bs-target="#heroCarousel"
            data-bs-slide="next"
          >
            <span className="custom-icon">
              <FaChevronRight />
            </span>
          </button>
        </div>
      </section>

      {/* Next Section */}
      <section>
        <div className="container mt-5">
          <div className="row g-4 align-items-center">
            <div className="col-12 col-md-6">
              <h2 className="sub-heading">
                Dedicated to improving Children’s Lives
              </h2>
              <p>
                Nurture Care Group specialises in providing therapeutic care to
                children aged 8-18 who have experienced considerable trauma
                throughout their lives.
              </p>

              <button className="read-more-btn">More About Us</button>
            </div>

            <div className="col-12 col-md-6">
              <img
                src={NurtureCareGroup}
                alt="Nurture Care Group"
                className="w-100 img-radius img-fluid"
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Slider;
